import builder from '../builder';
import OpenQuote from '../../streamline-icons/bold/open-quote.svg';

export default builder('OpenQuoteBold', OpenQuote);
